
import { defineComponent, computed, PropType, onMounted } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { object } from 'yup'
import { myValidationSchemaObj, validationMessage } from '@/views/validation'
import { useForm } from 'vee-validate'
import { HonbuhiUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import NumberWithComma from '@/views/components/NumberWithComma.vue'

type InputForm = {
  itemName: string;
  honbuhi: number;
  haifuhouhou: string;
}

const validationSchema = object({
  itemName: myValidationSchemaObj.maxString(20),
  honbuhi: myValidationSchemaObj.requiredPositiveNum,
  haifuhouhou: myValidationSchemaObj.maxString(100)
})

export default defineComponent({
  components: {
    NumberWithComma,
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<HonbuhiUiItem>,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: false,
      default: false
    },
    isLast: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    upItem: (item: HonbuhiUiItem) => true,
    downItem: (item: HonbuhiUiItem) => true,
    trashItem: (item: HonbuhiUiItem) => true,
    changeInput: (item: HonbuhiUiItem) => true
  },
  setup (props, { emit }) {
    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        itemName: props.item.item.itemName,
        honbuhi: props.item.item.honbuhi,
        haifuhouhou: props.item.item.haifukijun
      }
    })
    const headerName = computed(() => {
      if (!values.itemName) {
        return validationMessage.enterItem
      }
      return values.itemName
    })

    const onClickedUpItem = () => {
      emit('upItem', props.item)
    }

    const onClickedDownItem = () => {
      emit('downItem', props.item)
    }

    const onClickedTrashItem = () => {
      emit('trashItem', props.item)
    }

    const onChange = async () => {
      const item = props.item
      item.item.itemName = values.itemName
      item.item.honbuhi = values.honbuhi
      item.item.haifukijun = values.haifuhouhou
      await validate()
      item.isValid = meta.value.valid
      emit('changeInput', item)
    }

    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem = props.item
      propItem.item.settings = item
      emit('changeInput', propItem)
    }

    onMounted(async () => {
      await validate()
      const item = props.item
      item.isValid = meta.value.valid
      emit('changeInput', item)
    })

    return {
      headerName,
      errors,
      values,
      onClickedUpItem,
      onClickedDownItem,
      onClickedTrashItem,
      onChange,
      onUpdateKmk
    }
  }
})
